import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type SetInSeenlistMutationVariables = Types.Exact<{
	input: Types.SetInSeenlistInput;
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
	includeUnreleasedEpisodes: Types.Scalars['Boolean'];
	watchNowFilter: Types.WatchNowOfferFilter;
	platform?: Types.Platform;
}>;

export type SetInSeenlistMutation = { __typename?: 'Mutation' } & {
	setInSeenlist: { __typename?: 'SetInSeenlistPayload' } & {
		title:
			| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'> & {
						seenlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						show: { __typename?: 'Show' } & Pick<Types.Show, 'id' | 'objectId'> & {
								seenState: { __typename?: 'ShowSeenState' } & Pick<
									Types.ShowSeenState,
									'progress' | 'caughtUp'
								>;
								watchNextEpisode?: Types.Maybe<
									{ __typename?: 'Episode' } & Pick<
										Types.Episode,
										'id' | 'objectId' | 'objectType' | 'offerCount'
									> & {
											season: { __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
													content: { __typename?: 'SeasonContent' } & Pick<
														Types.SeasonContent,
														'fullPath' | 'posterUrl'
													>;
													seenState: { __typename?: 'ShowSeenState' } & Pick<
														Types.ShowSeenState,
														'releasedEpisodeCount' | 'seenEpisodeCount' | 'progress'
													>;
												};
											content: { __typename?: 'EpisodeContent' } & Pick<
												Types.EpisodeContent,
												'title' | 'episodeNumber' | 'seasonNumber'
											> & {
													upcomingReleases?: Types.Maybe<
														Array<
															{ __typename?: 'UpcomingRelease' } & Pick<
																Types.UpcomingRelease,
																'releaseDate' | 'label'
															>
														>
													>;
												};
											watchNowOffer?: Types.Maybe<
												{ __typename?: 'Offer' } & Pick<
													Types.Offer,
													| 'id'
													| 'standardWebURL'
													| 'retailPrice'
													| 'retailPriceValue'
													| 'currency'
													| 'lastChangeRetailPriceValue'
													| 'presentationType'
													| 'monetizationType'
													| 'availableTo'
												> & {
														package: { __typename?: 'Package' } & Pick<
															Types.Package,
															'id' | 'packageId' | 'clearName'
														>;
													}
											>;
										}
								>;
							};
						season: { __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
								seenState: { __typename?: 'ShowSeenState' } & Pick<
									Types.ShowSeenState,
									'progress' | 'caughtUp'
								>;
							};
					})
			| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id'> & {
						seenlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
					})
			| ({ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
						show: { __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
								seenState: { __typename?: 'ShowSeenState' } & Pick<
									Types.ShowSeenState,
									'progress' | 'caughtUp'
								>;
							};
						episodes: Array<
							{ __typename?: 'Episode' } & Pick<Types.Episode, 'id'> & {
									seenlistEntry?: Types.Maybe<
										{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
									>;
								}
						>;
						seenState: { __typename?: 'ShowSeenState' } & Pick<
							Types.ShowSeenState,
							'progress' | 'caughtUp'
						>;
					})
			| ({ __typename?: 'Show' } & Pick<Types.Show, 'id'> & {
						seenState: { __typename?: 'ShowSeenState' } & Pick<
							Types.ShowSeenState,
							'progress' | 'caughtUp'
						>;
						seasons: Array<
							{ __typename?: 'Season' } & Pick<Types.Season, 'id'> & {
									seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'progress'>;
									episodes: Array<
										{ __typename?: 'Episode' } & Pick<Types.Episode, 'id'> & {
												seenlistEntry?: Types.Maybe<
													{ __typename?: 'TitleListEntry' } & Pick<
														Types.TitleListEntry,
														'createdAt'
													>
												>;
											}
									>;
								}
						>;
					});
	};
};

export const SetInSeenlistDocument = gql`
	mutation SetInSeenlist(
		$input: SetInSeenlistInput!
		$country: Country!
		$language: Language!
		$includeUnreleasedEpisodes: Boolean!
		$watchNowFilter: WatchNowOfferFilter!
		$platform: Platform! = WEB
	) {
		setInSeenlist(input: $input) {
			title {
				id
				... on Movie {
					seenlistEntry {
						createdAt
					}
					watchlistEntry {
						createdAt
					}
				}
				... on Show {
					seenState(country: $country) {
						progress
						caughtUp
					}
					seasons {
						id
						seenState(country: $country) {
							progress
						}
						episodes {
							id
							seenlistEntry {
								createdAt
							}
						}
					}
				}
				... on Season {
					show {
						id
						seenState(country: $country) {
							progress
							caughtUp
						}
					}
					episodes {
						id
						seenlistEntry {
							createdAt
						}
					}
					seenState(country: $country) {
						progress
						caughtUp
					}
				}
				... on Episode {
					seenlistEntry {
						createdAt
					}
					show {
						id
						objectId
						seenState(country: $country) {
							progress
							caughtUp
						}
						watchNextEpisode(country: $country, includeUnreleasedEpisodes: $includeUnreleasedEpisodes) {
							id
							objectId
							objectType
							offerCount(country: $country, platform: $platform)
							season {
								id
								content(country: $country, language: $language) {
									fullPath
									posterUrl
								}
								seenState(country: $country) {
									releasedEpisodeCount
									seenEpisodeCount
									progress
								}
							}
							content(country: $country, language: $language) {
								title
								episodeNumber
								seasonNumber
								upcomingReleases(releaseTypes: [DIGITAL]) @include(if: $includeUnreleasedEpisodes) {
									releaseDate
									label
								}
							}
							watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
								id
								standardWebURL
								package {
									id
									packageId
									clearName
								}
								retailPrice(language: $language)
								retailPriceValue
								currency
								lastChangeRetailPriceValue
								presentationType
								monetizationType
								availableTo
							}
						}
					}
					season {
						id
						seenState(country: $country) {
							progress
							caughtUp
						}
					}
				}
			}
		}
	}
`;
